module.exports = __webpack_public_path__ + "img/2.e24bbee1.png";